import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { AnimatedTitle } from './AnimatedTitle';
import { Reveal, EASE } from './Reveal';
import { IconCircleButton } from './IconCircleButton';
import { testimonios } from '../data/testimonios';
export function Testimonios() {
  const reduce = useReducedMotion();
  return <section id="testimonios" className="grain relative isolate w-full overflow-hidden bg-gradient-to-b from-[#D94E1F] to-[#B8391A] py-24 lg:py-32" data-id="element-102" data-mp="2w1oavdaujqvq">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-[#2A0B10] to-transparent lg:h-40" data-id="element-103" data-mp="2r9emw2tal0w3" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12" data-id="element-104" data-mp="2ibb4hfdlsk8i">
        <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="2db6u873aglqq">
          <AnimatedTitle text="NO INICIES UN TRABAJO SIN ANTES SABER ESTO." className="font-serif text-4xl leading-[1.08] text-black sm:text-5xl lg:text-6xl" data-id="element-106" data-mp="2dangl2ko8jii" />
          <Reveal delay={0.1} data-id="element-107" data-mp="1nazx5l1yz066">
            <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-white/90 sm:text-lg" data-id="element-108" data-mp="1naq2vl9w66uo">
              Ningún ritual funciona sobre un corazón que duda. La fe y una actitud positiva son
              parte del trabajo: son la energía que tú aportas y la que sostiene cada conjuro. Te
              pedimos paciencia, discreción y confianza en el proceso; nosotros ponemos la
              experiencia, el acompañamiento y la honestidad de decirte siempre lo que sí se puede
              hacer y lo que no.
            </p>
          </Reveal>
        </div>

        <div className="mt-20" data-id="element-109" data-mp="1x1uhukzkhrpi">
          <Reveal data-id="element-110" data-mp="1x4qkunq9v6kt">
            <h3 className="text-center font-serif text-3xl text-white sm:text-4xl" data-id="element-111" data-mp="22178lgtk7ixd">
              ¡Lo que dicen sobre nosotros!
            </h3>
          </Reveal>
          <Reveal delay={0.08} data-id="element-112" data-mp="lpa7nfdugwqz">
            <div className="mx-auto mt-8 max-w-3xl overflow-hidden rounded-lg border-4 border-black/70 bg-black shadow-2xl shadow-black/40" data-id="element-113" data-mp="qm0po897m2f1">
              <video controls playsInline preload="metadata" className="mx-auto max-h-[70vh] w-full bg-black object-contain" src="https://cdn.magicpatterns.com/uploads/vcmDz9KsRyEitx7LN4rMXL/08bfe0a3-f399-412e-9f89-7b732fce68b8.mp4" data-id="element-114" data-mp="6jnz2o6pfsdn">
                Tu navegador no puede reproducir este video testimonial.
              </video>
            </div>
          </Reveal>
        </div>

        <ul className="mt-16 grid gap-6 [perspective:1200px] md:grid-cols-3" data-id="element-115" data-mp="3ezps2tt8y75d">
          {testimonios.map((t, i) => <motion.li key={t.id} initial={reduce ? undefined : {
          opacity: 0,
          rotateX: -12,
          y: 24
        }} whileInView={reduce ? undefined : {
          opacity: 1,
          rotateX: 0,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: i * 0.06
        }} className="group flex h-full flex-col rounded-lg bg-[#0D0D0D] p-8 shadow-xl shadow-black/30 transition-[transform,box-shadow] duration-300 ease-out hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-black/60 motion-reduce:transition-none motion-reduce:hover:translate-y-0" data-id="element-116" data-mp="3az70n0v9n33p" data-mpi={i}>
              <QuoteIcon className="h-6 w-6 text-[#E0A526]" aria-hidden="true" data-id="element-117" data-mp="1ljmlf9rvm357" />
              <p className="mt-5 flex-1 text-sm leading-relaxed text-neutral-300" data-id="element-118" data-mp="1qifxcxrilm39">{t.texto}</p>
              <div className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-119" data-mp="sufk6311ezg9">
                <img src={t.foto} alt={`Retrato de ${t.nombre}`} loading="lazy" className="h-14 w-14 shrink-0 rounded-full object-cover" data-id="element-120" data-mp="xs7knlfqztw2" />
                <div data-id="element-121" data-mp="16q18s93czh85">
                  <p className="font-serif text-lg text-white" data-id="element-122" data-mp="2e6h0ts9u6cbt">{t.nombre}</p>
                  <p className="text-xs uppercase tracking-[0.16em] text-[#E0A526]" data-id="element-123" data-mp="2e8abrjrhfipm">{t.ciudad}</p>
                </div>
              </div>
            </motion.li>)}
        </ul>

        <Reveal delay={0.1} data-id="element-124" data-mp="2gsgejo4d134l">
          <div className="mt-14 flex flex-wrap items-center justify-center gap-5" data-id="element-125" data-mp="2brivzaffu72k">
            <IconCircleButton accion="llamada" tamano="lg" data-id="element-126" data-mp="2qojohg5ge623" />
            <IconCircleButton accion="whatsapp" tamano="lg" data-id="element-127" data-mp="2qq4in4nuvmzf" />
          </div>
        </Reveal>
      </div>
    </section>;
}